export async function fetchTranslations(component: string) {
  const res = await fetch(`/translations/${component}`, { credentials: "include" })
  return res.ok ? res.json() : {}
}
